import "@aws-amplify/ui-react/styles.css";
import {
    Box,
    Heading,
    Stack,
    Center,
    Image,
    Text,
    VStack,
    Wrap,
    WrapItem,
    Flex,
    Spacer,
    SimpleGrid
} from '@chakra-ui/react'
import React from "react";
import PostDisplay from "../controls/PostDisplay";
import BasePage from "../controls/BasePage";
import { LoadingBlock } from "../controls/LoadingBlock";
import PageTitle from "../controls/PageTitle";
import { DataUtils, ImageSize } from "../clients/data-service";

const introPostId = '202302252';
const bannerImageId = '1c1012e8-27ae-4bdc-b606-459f97e043b8';

class Home extends BasePage {
    render() {

        const introPost = this.state?.data?.Posts.find(p => p.id === introPostId);


        return (<>
            <Box alignItems="center" justifyContent="space-between" mb={20}>
                {/* <Box w='100%' h='400' columns={3} spacing={20} mt={0} backgroundImage='/bannerpale.jpg' backgroundPosition='center' backgroundSize='cover' >
                    <Center>
                        <SimpleGrid columns={3} spacing={20} mt={0} h='100%' >
                            <Center><Image boxSize='128px' src="/WhiteShieldLogo.png" /></Center>
                            <Center><Image boxSize='192px' src="/logotransp192.png" /></Center>
                            <Center><Image boxSize='128px' src="/logo2.png" /></Center>
                        </SimpleGrid>
                    </Center>
                </Box> */}
                <Image w='100%' h={{ base: 200, md: 500 }} fit='cover' src='/1931Team.jpg' />
                <PageTitle>Enfield Federals - Past Players & Supporters Club</PageTitle>
                <Center>
                    <VStack alignContent='center' justifyContent='center'>
                        <Center>
                            <SimpleGrid columns={3} spacing={{ base: 4, md: 20 }} mt={0}>
                                <Center><Image boxSize={{ base: '64px', md: '128px' }} src="/WhiteShieldLogo.png" /></Center>
                                <Center><Image boxSize={{ base: '96px', md: '192px' }} src="/logotransp192.png" /></Center>
                                <Center><Image boxSize={{ base: '64px', md: '128px' }} src="/Logo2.png" /></Center>
                            </SimpleGrid>
                        </Center>
                    </VStack>
                </Center>
                <Center>
                    <Box w="fill" m={10} maxW="1000">
                        {introPost ? (<PostDisplay post={introPost} embeded={true} siteData={this.state.data!} />) : <LoadingBlock />}
                    </Box>
                </Center>
                <Center >
                    <SimpleGrid columns={3} spacing={{ base: 4, md: 20 }} mt={0} >
                        <Center><Heading fontSize={{ base: 'sm', md: 'lg' }} verticalAlign='bottom'>Sponsored by</Heading></Center>
                        <Image boxSize={{ base: '64px', md: '160px' }} src="/Laundy_logo-White.png" />
                        <Image boxSize={{ base: '64px', md: '160px' }} src="/Crossways_Logo-Green.png" />
                    </SimpleGrid>
                </Center>
            </Box>
        </>
        )
    }
}

export default Home;